import React, { Component } from "react";
import { FaUser } from "react-icons/fa";
import Background from "../assets/images/bg_page.png";
import axios from "axios";
import { admission } from "../Pages/ADMISSION";
import { academicYearFullLabel } from "../config/academicYear";
import "./Headers.css";

const base = process.env.REACT_APP_BASENAME || "";

export default class HeadersPresent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      LEVEL_OPEN_ID: null,
      checkstatus: null,
      menuOpen: false,
      openId: null,
    };
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    axios
      .get(admission + "/student/loadpresent/" + localStorage.getItem("ID_LOGIN"))
      .then((res) => {
        const rows = (Array.isArray(res.data) ? res.data : []).filter(
          ({ REGISTER_STATUS }) => REGISTER_STATUS !== "11"
        );
        if (!rows.length) return;
        this.setState({
          name: "คุณ " + rows[0]["FRISTNAME_LOGIN"] + " " + rows[0]["LASTNAME_LOGIN"],
          LEVEL_OPEN_ID: rows[0]["LEVEL_OPEN_ID"],
          checkstatus: "1",
        });
      })
      .catch(() => {
        this.setState({ checkstatus: "1" });
      });

    this.onResize = () => {
      if (window.innerWidth > 992) {
        this.setState({ menuOpen: false, openId: null });
      }
    };
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  handleLogout() {
    localStorage.clear();
    window.location.href = `${base}/`;
  }

  setOpenId = (id) => {
    this.setState({ openId: id });
  };

  brandHref() {
    return this.state.checkstatus === "0" ? `${base}/Insertpresent1` : `${base}/Present`;
  }

  presentItems() {
    const items = [{ href: `${base}/Insertpresent1`, label: "ข้อมูลประวัติส่วนตัว" }];
    if (this.state.checkstatus === "0") return items;

    items.push(
      { href: `${base}/Insertpresent2`, label: "ข้อมูลประวัติการศึกษา" },
      { href: `${base}/Insertpresent3`, label: "ข้อมูลที่อยู่" },
      { href: `${base}/Insertpresent4`, label: "ข้อมูลผู้ปกครอง" },
      { href: `${base}/Insertpresent5`, label: "ข้อมูลการมีงานทำ" },
      { href: `${base}/Insertpresent6`, label: "ข้อมูลความสามารถพิเศษ" },
      { href: `${base}/Insertpresent7`, label: "ข้อมูลช่องทางการรับข่าวสารการรับสมัคร" },
      { href: `${base}/Insertpresent8`, label: "ข้อมูลรูปประจำตัว" },
      { href: `${base}/Insertpresent9`, label: "ข้อมูลไฟล์เอกสารประกอบการรายงานตัว" }
    );

    if (this.state.LEVEL_OPEN_ID === "4" || this.state.LEVEL_OPEN_ID === "19") {
      items.push({
        href: `${base}/Insertpresent10`,
        label: "ข้อมูลไฟล์เอกสารผลคะแนน PAT 5",
      });
    }

    return items;
  }

  render() {
    const { menuOpen, openId, name } = this.state;
    const presentOpen = openId === "present";
    const userOpen = openId === "user";

    return (
      <header className="site-header">
        <div className="site-header__top">
          <div className="site-header__top-inner">
            <a className="site-header__brand" href={this.brandHref()}>
              ระบบรับสมัครนักศึกษา
            </a>
            <div className="site-header__staff">
              <span>ขั้นตอนรายงานตัวเข้าศึกษา</span>
            </div>
          </div>
        </div>

        <nav className="site-header__nav" aria-label="เมนูรายงานตัว">
          <div className="site-header__nav-inner">
            <button
              type="button"
              className="site-header__toggle"
              aria-expanded={menuOpen}
              aria-controls="site-header-present-menu"
              onClick={() =>
                this.setState((s) => ({ menuOpen: !s.menuOpen, openId: null }))
              }
            >
              {menuOpen ? "ปิดเมนู" : "เมนู"}
            </button>

            <ul
              id="site-header-present-menu"
              className={`site-header__menu${menuOpen ? " is-open" : ""}`}
            >
              <li className={presentOpen ? "is-open" : ""}>
                <button
                  type="button"
                  className="site-header__drop-btn"
                  aria-expanded={presentOpen}
                  onClick={() => this.setOpenId(presentOpen ? null : "present")}
                >
                  กรอกข้อมูลรายงานตัว
                  <span className="site-header__caret" aria-hidden="true">
                    ▾
                  </span>
                </button>
                <ul className="site-header__dropdown">
                  {this.presentItems().map((item) => (
                    <li key={item.href}>
                      <a href={item.href}>{item.label}</a>
                    </li>
                  ))}
                </ul>
              </li>

              <li>
                <a href={`${base}/waiver`}>แบบฟอร์มขอสละสิทธิ์การเข้าศึกษา</a>
              </li>

              <li className={`site-header__menu-end${userOpen ? " is-open" : ""}`}>
                <button
                  type="button"
                  className="site-header__drop-btn"
                  aria-expanded={userOpen}
                  onClick={() => this.setOpenId(userOpen ? null : "user")}
                >
                  <span className="site-header__user-icon" aria-hidden="true">
                    <FaUser size={14} />
                  </span>
                  {name || "บัญชีผู้ใช้"}
                  <span className="site-header__caret" aria-hidden="true">
                    ▾
                  </span>
                </button>
                <ul className="site-header__dropdown site-header__dropdown--end">
                  <li>
                    <button
                      type="button"
                      className="site-header__logout"
                      onClick={this.handleLogout}
                    >
                      ออกจากระบบ
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>

        <div
          className="site-header__hero"
          style={{ backgroundImage: `url(${Background})` }}
        >
          <div className="site-header__hero-inner">
            <h1>มหาวิทยาลัยราชภัฏกำแพงเพชร</h1>
            <p>
              เปิดรับสมัครนักศึกษาใหม่ <strong>{academicYearFullLabel()}</strong>
            </p>
            <ul className="site-header__contacts">
              <li>
                ภาคปกติ - ภาค กศ.บป. · (055) 706 547 ·{" "}
                <a
                  href="https://www.facebook.com/kpru.register"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                ปริญญาโท - ปริญญาเอก · (055) 706 555 ต่อ 1770, 1780 ·{" "}
                <a
                  href="https://www.facebook.com/graduateskpru/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li>
                ประกาศนียบัตรบัณฑิต · (055) 706 555 ต่อ 2010 ·{" "}
                <a href="https://www.facebook.com/edukpru/" target="_blank" rel="noreferrer">
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>
    );
  }
}
